import React from 'react';

const TicketVariant = ({ti="", id="" }) => {
  
    return <strong>{ti}</strong>
}

export default TicketVariant

